import { cx } from "./controlStyles";

// Small round dot for state (agent running, container health, job
// result). Always paired with text — colour is never the only cue.
// `pulse` is a gentle blink for "in progress" (off for reduced motion).

type Tone =
  | "neutral"
  | "active"
  | "idle"
  | "warn"
  | "error"
  | "accent"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "live";

const tones: Record<Tone, string> = {
  neutral: "bg-[color:var(--c-text-faint)]",
  idle: "bg-[color:var(--c-text-faint)]",
  active: "bg-success",
  success: "bg-success",
  warn: "bg-warning",
  warning: "bg-warning",
  error: "bg-danger",
  danger: "bg-danger",
  info: "bg-info",
  accent: "bg-[color:var(--c-accent-light)]",
  // live work: the accent unless the theme sets its own (Earth)
  live: "bg-live",
};

interface StatusDotProps {
  tone?: Tone;
  /** sm = 6px (default), md = 8px. */
  size?: "sm" | "md";
  pulse?: boolean;
  className?: string;
}

export function StatusDot({ tone = "neutral", size = "sm", pulse, className }: StatusDotProps) {
  return (
    <span
      className={cx(
        "inline-block shrink-0 rounded-full",
        size === "md" ? "h-[8px] w-[8px]" : "h-[6px] w-[6px]",
        tones[tone],
        pulse && "motion-safe:animate-pulse",
        className,
      )}
      aria-hidden
    />
  );
}
